<template>
  <div class="flex max-md:gap-4 max-md:flex-col justify-between items-center p-8">
    <button v-if="!prevStepHidden" type="button" class="btn font-semibold text-body" @click.prevent="prevStep()">
      Retour
    </button>
    <button
      type="button"
      class="btn btn-primary py-4 px-8 md:ml-auto max-md:w-full"
      :disabled="nextStepDisabled"
      @click.prevent="nextStep()"
    >
      Continuer
    </button>
  </div>
</template>

<script>
export default {
  name: 'StepsNavigation',
  props: {
    prevStepHidden: {
      type: Boolean,
      default: false
    },
    nextStepDisabled: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    nextStep() {
      this.$emit('nextStep')
    },
    prevStep() {
      this.$emit('prevStep')
    }
  }
}
</script>
